import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "@/lib/api";

const CurrencyContext = createContext({ currency: "USD", rate: 1, usd_to_inr: 85 });

export function CurrencyProvider({ children }) {
  const [ctx, setCtx] = useState({ currency: "USD", rate: 1, usd_to_inr: 85 });

  useEffect(() => {
    axios
      .get(`${API_BASE}/currency/context`)
      .then((r) => {
        if (r.data?.currency && r.data?.rate) setCtx((c) => ({ ...c, ...r.data }));
      })
      .catch(() => {});
  }, []);

  return <CurrencyContext.Provider value={ctx}>{children}</CurrencyContext.Provider>;
}

export function useCurrency() {
  const { currency, rate, usd_to_inr } = useContext(CurrencyContext);

  const format = (usd) => {
    if (currency === "USD") return `$${Number(usd) % 1 === 0 ? usd : Number(usd).toFixed(2)}`;
    const converted = usd * rate;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        maximumFractionDigits: converted >= 100 ? 0 : 2,
      }).format(converted);
    } catch {
      return `$${usd}`;
    }
  };

  const formatInr = (inr) => {
    if (currency === "INR") return `₹${Number(inr).toLocaleString("en-IN")}`;
    const converted = (inr / usd_to_inr) * rate;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        maximumFractionDigits: converted >= 100 ? 0 : 2,
      }).format(converted);
    } catch {
      return `₹${inr}`;
    }
  };

  return { currency, rate, format, formatInr, isUsd: currency === "USD", isInr: currency === "INR" };
}
